export default "__VITE_ASSET__BjeCyu7x__"